import s from './info.module.css';
import React from "react";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";

const Info = () => {
    useDocumentTitle('О нас');


    return (
        <div className={s.info}>
            <div className={`${s.infoContent} content`}>
                <Breadcrumbs/>
                <div className={s.infoMain}>
                    <h3>О нас</h3>
                    <h5>Интернет магазин домашнего текстиля "Статус-Текстиль" в Украине / Полтаве.</h5>
                    <p>Компания <strong>"Статус-Текстиль"</strong> более 10 лет успешно работает на рынке домашнего
                        текстиля в Украине.
                        Наша компания - одна из крупнейших торговых организаций в Полтавском регионе.
                        Мы предлагаем только качественные и недорогие изделия от лучших украинских производителей
                        домашнего текстиля в Украине.
                        Весь товар сертифицирован.

                        На сегодняшний день, рынок домашнего текстиля динамично развивается и это касается
                        не только готовых изделий но и тканей, фурнитуры, всевозможных материалов и еще много всего.
                        "Статус-Текстиль старается как можно быстрее реагировать на изменения ситуации на рынке, успешно
                        конкурировать по цене, качеству и отношению к покупателям.
                    </p>
                    <p>Наша компания предлагает продукцию таких торговых марок:</p>
                    <ul>
                        <li><strong>Фабрика "Ярослав", г. Киев (махровые изделия, пледы, подушки);</strong></li>
                        <li><strong>Фабрика "Влади" (Vladi), г. Харьков (шерстяные, полушерстяные одеяла,
                            пледы);</strong></li>
                        <li><strong>Фабрика "Вилюта" (Viluta), г. Днепр (постельное белье, одеяла, постельные
                            принадлежности).</strong></li>
                    </ul>
                    <p>Особенностью нашего интернет-магазина является исключительно натуральное сырье, из которого
                        изготавливается продукция.
                    </p>
                    <p>Говоря о <strong>махровых изделиях</strong>, подразумевается только стопроцентный, натуральный
                        хлопок, без каких либо примесей и добавок.
                    </p>
                    <p>
                        <strong>Шерстяные одеяла и пледы</strong> - только из натуральной шерсти.
                    </p>
                    <p><strong>Постельное белье</strong> изготавливается только из натурального хлопка: бязь, сатин,
                        жаккард, люкс - ассортимент огромен.</p>
                    <p>Также, "Статус-Текстиль" предлагает приятные мелочи для <strong>декора Вашего дома</strong>,
                        которые подчеркнут стиль и дизайн интерьера.
                    </p>
                    <p>И все это - <strong>по самой низкой цене</strong>. Мы работаем напрямую с
                        заводами-производителями, это позволяет
                        нам держать цена на самом низком уровне.
                    </p>
                    <p>"Статус-Текстиль" работает в двух направлениях : <strong>опт и розница.</strong></p>
                    <p>Обслуживаем гостиницы, пансионаты, детские сады, курорты, корпоративных клиентов. Делаем вышивку
                        логотипа на готовых изделиях. Все условия оптовых сделок обсуждаются индивидуально.
                    </p>
                    <p>Помимо реализации готовых текстильных изделий, "Статус-Текстиль" также может предложить:</p>
                    <ul>
                        <li><strong>Ткани для спецодежды;
                        </strong></li>
                        <li><strong>Синтепон любой плотности;
                        </strong></li>
                        <li><strong>Бязь отбеленная и черная подкладочная;
                        </strong></li>
                        <li><strong>Махровое полотно в рулонах (производство Узбекистан);
                        </strong></li>
                        <li><strong>Брезентовые рукавицы с наладонником и без;
                        </strong></li>
                        <li><strong>Хозяйственные пятипалые рукавицы;
                        </strong></li>
                        <li><strong>Чулочно-носочные изделия (носки, гетры, гамаши);
                        </strong></li>
                        <li><strong>Трикотажные изделия (нательное белье, футболки, майки);
                        </strong></li>
                        <li><strong>Пошив спецформы (костюм пожарника, инженера, медхалаты, и т.д.);
                        </strong></li>
                        <li><strong>Принимаем заказы на пошив спецодежды по Вашим техническим условиям (от 5 единиц);
                        </strong></li>
                        <li><strong>Делаем вышивку Вашего логотипа на готовых текстильных изделиях.
                        </strong></li>
                    </ul>
                    <p>Если чего то в этом списке нет, а это Вам очень нужно и относиться к категории домашний текстиль
                        - звоните, найдем специально для Вас!
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Info;